import { render, staticRenderFns } from "./BmvCollapse.vue?vue&type=template&id=99249c16&scoped=true"
import script from "./BmvCollapse.vue?vue&type=script&lang=js"
export * from "./BmvCollapse.vue?vue&type=script&lang=js"
import style0 from "./BmvCollapse.vue?vue&type=style&index=0&id=99249c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99249c16",
  null
  
)

export default component.exports